// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1y9Ro","alertIcon":"ConfirmModal_alertIcon__25RjD"};